module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1900.7142c647.svg";